export default {"src":"/_next/static/media/facebook.439cbbb2.svg","height":32,"width":32};